import { isEqual, uniqWith } from "lodash";
import { Option } from "models/Option";

export const getUniqueOptions = <T>(options: Option<T>[]) =>
  uniqWith(options, isEqual).sort((a, b) => a.text.localeCompare(b.text));
